import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import easing from 'ui/styles/easing'
import posed, { PoseGroup } from 'react-pose'
import InViewMonitor from 'react-inview-monitor'

import Quote from './Quote'

const AnimWrapper = posed.div({
  preEnter: {
    opacity: 0,
    x: (direction) => direction === 'right' ? '-25%' : '25%'
  },
  
  enter: {
    opacity: 1,
    x: 0
  },
  
  exit: {
    opacity: 0,
    x: (direction) => direction === 'right' ? '25%' : '-25%'
  }

})

const ModuleWrapper = styled.div`
  transform: ${props => props.inView ? 'translateY(0px)' : 'translateY(30px)'};
  opacity: ${props => props.inView ? 1 : 0};
  transition: transform 0.6s ${easing.easeOutCubic}, opacity 0.6s ${easing.easeOutCubic};
  margin-bottom: 80px;
`

const Wrapper = styled.div`
  background: ${props => props.theme.colors.grey.lightest};
  margin-bottom: 150px;

  ${media.xs`
    margin-bottom: 0;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 15px;
      background: ${props => props.theme.colors.grey.lightest}
    }
  `}
`

const Image = styled.div`
  display: block;
  width: 100%;
  background: url(${props => props.image}) center / cover;
  padding-bottom: 51%;
  height: 0;

  ${media.lg`
    transform: translateY(50px);
    height: 100%;
    padding-bottom: 0;
  `}

  ${media.xs`
    display: none;
  `}
`

const Controls = styled.div`
  display: flex;
  justify-content: flex-end;

  ${media.lg`
    position: absolute;
    bottom: 0;
    right: 100%;
    margin-right: -10px;
  `}

  ${media.xs`
    position: relative;
    margin-right: 0;
    margin-top: 15px;
    right: 0;
  `}
`

const Button = styled.button`
  background: ${props => props.theme.colors.theme.base};
  height: 40px;
  width: 80px;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transition: transform 0.3s ${easing.easeOutCubic};
  }

  &:first-child {
    border-right: 1px solid ${props => props.theme.colors.theme.dark};

    svg {
      transform: rotate(180deg);
    }

    &:hover {
      svg {
        transform: rotate(180deg) translateX(25%);
      } 
    }
  }

  svg path {
    fill: ${props => props.disabled ? props.theme.colors.theme.dark : props.theme.colors.grey.lightest};
    transition: fill 0.3s ${easing.easeOutCubic};
  }

  &:hover {
    cursor: pointer;

    svg {
      transform: translateX(25%);
    }
  }
`

export default class Quotes extends Component {
  state = {
    activeQuote: 0,
    quoteContent: [this.props.quotes[0]],
    direction: 'right'
  }

  nextQuote() {
    const newActiveQuote = this.state.activeQuote + 1
    
    this.setState({
      direction: 'right',
      activeQuote: newActiveQuote,
      quoteContent: [this.props.quotes[newActiveQuote]]
    })
  }
  
  prevQuote() {
    const newActiveQuote = this.state.activeQuote - 1
    
    this.setState({
      direction: 'left',
      activeQuote: newActiveQuote,
      quoteContent: [this.props.quotes[newActiveQuote]]
    })
  }
  
  render() {
    const {
      image,
      quotes
    } = this.props

    const {
      activeQuote,
      direction,
      quoteContent
    } = this.state

    return(
      <InViewMonitor childPropsInView={{inView: true}}>
        <ModuleWrapper>
          <Container fluid>
            <Wrapper>
              <Row>
                <Col
                  lg={4}
                  lgOffset={1}
                >
                  <PoseGroup
                    preEnterPose="preEnter"
                  >
                      {quoteContent.map(quote => {
                        return(
                          <AnimWrapper
                            key={Math.random()}
                            direction={direction}
                            withParent={false}
                          >
                            <Quote key={Math.random()} {...quote} />
                          </AnimWrapper>
                        )
                      })}
                  </PoseGroup>
                </Col>
                <Col
                  lg={6}
                  lgOffset={1}
                >
                  <Controls>
                    <Button
                      onClick={() => this.prevQuote()}
                      disabled={!activeQuote}
                    >
                      <svg
                        width="19"
                        height="16"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.89891421 14.873342c-.15886232.1491125-.28188712.1887755-.48300577.1887755h-.86197469c-.36078327 0-.44315634-.2424962-.20085135-.4699303l6.84525125-6.4251412H.4011678c-.2607587 0-.4011673-.1317913-.4011673-.3765467v-.5188812c0-.2447554.1404086-.3765467.4011673-.3765467h15.79716585L9.3530824.4699302C9.11077741.2424961 9.19315048-1e-7 9.55420105-1e-7h.86197469c.20111865 0 .3417945.056482.48273806.1887755l7.5411429 7.0783243c.18106029.1699482.18106029.3579706 0 .5279188l-7.5411429 7.0783242 4.1e-7-7e-7z"
                        />
                      </svg>
                    </Button>
                    <Button
                      onClick={() => this.nextQuote()}
                      disabled={activeQuote === quotes.length - 1}
                    >
                      <svg
                        width="19"
                        height="16"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.89891421 14.873342c-.15886232.1491125-.28188712.1887755-.48300577.1887755h-.86197469c-.36078327 0-.44315634-.2424962-.20085135-.4699303l6.84525125-6.4251412H.4011678c-.2607587 0-.4011673-.1317913-.4011673-.3765467v-.5188812c0-.2447554.1404086-.3765467.4011673-.3765467h15.79716585L9.3530824.4699302C9.11077741.2424961 9.19315048-1e-7 9.55420105-1e-7h.86197469c.20111865 0 .3417945.056482.48273806.1887755l7.5411429 7.0783243c.18106029.1699482.18106029.3579706 0 .5279188l-7.5411429 7.0783242 4.1e-7-7e-7z"
                        />
                      </svg>
                    </Button>
                  </Controls>
                  <Image image={image.sourceUrl} />
                </Col>
              </Row>
            </Wrapper>
          </Container>
        </ModuleWrapper>
      </InViewMonitor>

    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Quotes/index.js